export default __webpack_public_path__ + "static/media/xmas.4c03fb2c.jpg";